import {Injectable} from '@angular/core';
import {Subject} from "rxjs/Subject";

@Injectable()
export class LoadingWheelService {
    loading: boolean;
    _loadingSubject: Subject<boolean> = new Subject();

    constructor(){
        this.loading = false;
    }

    isLoading(): boolean {
        return this.loading;
    }

    show() {
        this.loading = true;
        this._loadingSubject.next(true);
    };

    hide() {
        this.loading = false;
        this._loadingSubject.next(false);
    };

    get loadingSubject(): Subject<boolean> {
        return this._loadingSubject;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/root/loading/loading-wheel.service.ts